export default {
  name: 'pc-separator',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '分割线',
          icon: 'el-icon-minus',
          type: '辅助类',
          content: {
            margin: '0',
            type: 'border-solid',
            color: '#333'
          },
          config: [{
            label: '左右边距',
            name: 'margin',
            type: 'number',
            value: '0'
          }, {
            label: '颜色',
            name: 'color',
            type: 'color',
            value: ''
          }, {
            label: '线条类型',
            name: 'type',
            type: 'select',
            options: [{
              label: '实线',
              value: 'border-solid'
            }, {
              label: '虚线',
              value: 'border-dashed'
            }, {
              label: '斑点线',
              value: 'border-dotted'
            }]
          }]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};